import React, { createContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/fire';

export const LogoContext = createContext();

export const LogoProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(localStorage.getItem('logoUrl') || '');

  useEffect(() => {
    const fetchLogo = async () => {
      if (logoUrl) return;

      try {
        const logoDoc = await getDoc(doc(db, "settings", "logo"));
        if (logoDoc.exists()) {
          const url = logoDoc.data().url;
          setLogoUrl(url);
          localStorage.setItem('logoUrl', url);
        }
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };

    fetchLogo();
  }, [logoUrl]);

  return (
    <LogoContext.Provider value={[logoUrl, setLogoUrl]}>
      {children}
    </LogoContext.Provider>

  );
};
